import { creatorListsActionTypes } from "../constants";

const initialState = {
  loading: false,
  lists: [],
  formattedOptions: [],
  count: 0,
  dismissModal: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case creatorListsActionTypes.getCreatorLists.REQUEST:
      return {
        ...state,
        loading: true,
        dismissModal: false,
      };
    case creatorListsActionTypes.getCreatorLists.SUCCESS:      
      return {
        ...state,
        loading: false,
        lists: payload?.results,
        formattedOptions: payload?.formattedOptions,
        count: payload?.count,
        dismissModal: false,
      };
    case creatorListsActionTypes.getCreatorLists.FAILURE:
      return {
        ...state,
        loading: false,
        lists: [],
        formattedOptions: [],
        count: 0,
        dismissModal: false,
      };
    case creatorListsActionTypes.getCreatorListsSelectOptions.REQUEST:
      return {
        ...state,
        loadingOptions: true,
      };
    case creatorListsActionTypes.getCreatorListsSelectOptions.SUCCESS:      
      return {
        ...state,
        loadingOptions: false,
        formattedOptions: payload?.formattedOptions,
        count: payload?.count,
      };
    case creatorListsActionTypes.getCreatorListsSelectOptions.FAILURE:
      return {
        ...state,
        loadingOptions: false,
        formattedOptions: [],
        count: 0,
      };

    case creatorListsActionTypes.createCreatorList.REQUEST:
      return {
        ...state,
        loading: true,
        dismissModal: false,
      };
    case creatorListsActionTypes.createCreatorList.SUCCESS:
      return {
        ...state,
        loading: false,
        dismissModal: true,
      };
    case creatorListsActionTypes.createCreatorList.FAILURE:
      return {
        ...state,
        loading: false,
        dismissModal: false,
      };

    case creatorListsActionTypes.updateCreatorList.REQUEST:
      return {
        ...state,
        loading: true,
        dismissModal: false,
      };
    case creatorListsActionTypes.updateCreatorList.SUCCESS:
      return {
        ...state,
        loading: false,
        dismissModal: true,
      };
    case creatorListsActionTypes.updateCreatorList.FAILURE:
      return {
        ...state,
        loading: false,
        dismissModal: false,
      };
    case creatorListsActionTypes.addSharedUser.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case creatorListsActionTypes.addSharedUser.SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case creatorListsActionTypes.addSharedUser.FAILURE:
      return {
        ...state,
        loading: false,
      };

    default: {
      return state;
    }
  }
};
